import React from 'react'
import { camelCase } from 'lodash'
import { QueryListFilter } from '@feedyou-ai/feedbot-schema'

import { ColumnName } from '../../hooks/types'

interface Props {
  name: ColumnName
  uncommitedFilter: {
    filter: QueryListFilter
    setFilterValue<K extends keyof QueryListFilter>(key: K, val: QueryListFilter[K]): void
  }
}

export const RatingOptions: React.FC<Props> = ({ name, uncommitedFilter }) => {
  const propertyName = camelCase(name) as keyof QueryListFilter
  return (
    <select
      id={name}
      name={name}
      defaultValue=""
      value={uncommitedFilter.filter[propertyName] || ''}
      onChange={e =>
        uncommitedFilter.setFilterValue(
          propertyName,
          e.target.value ? Number(e.target.value) : undefined
        )
      }
    >
      <option value=""></option>
      <option value="1">1</option>
      <option value="-1">-1</option>
    </select>
  )
}
